import { BusinessType, GetCompanyInfoQuery } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const getCompanyInfoHandler = graphql.query<GetCompanyInfoQuery>(
  "getCompanyInfo",
  ({ query, variables }) => {
    return HttpResponse.json({
      data: {
        // company: null,
        company: {
          companyID: 1,
          branchOfficeId: 3,
          displayCompanyId: "9999-012345",
          companyNameStoreName: "事業者１",
          companyNameStoreNameKana: "ジギョウシャイチ",
          representativeName: "代表",
          representativeEmailAddress: "aaaaa@example.com",
          phoneNumber: "09099999999",
          industriesLarge: "G",
          industriesMiddle: "39",
          postalCode: "1112222",
          prefectures: "01",
          municipality: "あいう市",
          blockBuildingName: "５丁目",
          settlementMonth: "06",
          foundationDate: "2007-09-09",
          capital: 1000000,
          staffCount: "03",
          siteUrl: "https://mfbank.id.x.test.mfw.work/",
          businessContent: "商品の販売",
          corporateNumber: "1234567890123",
          qualifiedInvoiceIssuerRegistrationNumber: "T1234567890123",
          mainUserName: "山田太郎",
          mainUserPhoneNumber: "0300001111",
          insuranceAgencyCode: "989899",
          insuranceAgencyName: "田町代理店",
          companyBusinessType: BusinessType.Corporate,
          representativeBirthDate: "1980-01-01",
        },
      },
    });
  }
);
